<template>
    <div class="log_page">
        <div class="search_box">
            <div class="form_item">
                <span>医生姓名：</span>
                <Input v-model="doctorName" placeholder="请输入" style="width: 200px" />
            </div>
            <div class="form_item">
                <DatePicker type="daterange" placeholder="请选择日期" style="width: 250px" v-model="searchDate"></DatePicker>
            </div>
            <div class="btn">
                <Button type="primary" @click="search">查询</Button>
            </div>
        </div>
        <div class="table_box">
            <Table :columns="columns1" :data="data1">
                <template slot-scope="{ row }" slot="operation">
                    <span style="color:#1890FF;" v-if="row.IsSuccess == 'T'">成功</span>
                    <Poptip placement="bottom" v-else word-wrap :content="row.FailLog">
                        <span style="color:#FF4F66;cursor:pointer;">失败</span>
                    </Poptip>
                </template>
            </Table>
        </div>
        <div class="pagination">
            <Page :page-size="pageSize" :current="this.pageNum" :total="this.total" show-total @on-change="pageChange" />
        </div>
    </div>
</template>

<script>
import { Input,DatePicker,Button,Table,Poptip,Page } from 'view-design'
import dayjs from "dayjs"
import Request from "../utils/request"
import Config from "../config"
export default {
    components: {
        Input,DatePicker,Button,Table,Poptip,Page
    },
    data() {
        return {
            doctorName:'',
            searchDate:[],
            columns1: [
                {
                    title: "姓名",
                    key: "ODocName",
                    align: "center",
                },
                {
                    title: "账号",
                    key: "Cellphone",
                    align: "center",
                },
                {
                    title: "操作时间",
                    key: "CrtDate",
                    align: "center",
                },
                {
                    title: "操作模块",
                    key: "Modules",
                    align: "center",
                },
                {
                    title: "操作类型",
                    key: "Type",
                    align: "center",
                },
                {
                    title: "客户端",
                    key: "Client",
                    align: "center",
                },
                {
                    title: "操作结果",
                    align: "center",
                    slot:'operation'
                },
            ],
            data1: [],
            pageNum:1,
            pageSize:10,
            total:0
        };
    },
    methods: {
        search(){
            this.pageNum = 1
            this.getLogList()
        },
        pageChange(page){
            this.pageNum = page
            this.getLogList()
        },
        getLogList(){
            Request.getRequest(Config.SXG_baseUrl + '/api/casemanager/GetSysLog',{
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                startDate:this.searchDate[0] ? dayjs(this.searchDate[0]).format('YYYY-MM-DD') : '',
                endDate:this.searchDate[1] ? dayjs(this.searchDate[1]).format('YYYY-MM-DD') : '',
                searchkey:'ODocName',
                searchvalue:this.doctorName
            }).then(res=>{
                if(res.code == 200){
                    res.data.Record.map(item=>{
                        item.CrtDate = item.CrtDate.replace("T"," ")
                    })
                    this.data1 = res.data.Record
                    this.total = res.data.count
                }else{
                    this.$Message.error(res.message)
                }
            })
        }
    },
    created() {
        this.$emit("funChangeTitle", "系统日志", "3-4");
        this.getLogList()
    },
    mounted() {

    },
}
</script>
<style lang='less'>
    .log_page{
        padding:20px 30px 60px;
        .search_box{
            display: flex;
            align-items: center;
            margin:5px 0 20px;
            .form_item{
                margin-right:30px;
            }
        }
        .table_box{
            .ivu-poptip-popper{
                min-width: auto;
            }
            .ivu-table-wrapper{
                overflow: visible;
            }
        }
        .pagination{
            position: fixed;
            bottom: 30px;
            right: 100px;
        }
    }
</style>